/* ==================================================================
   Rêve Èclatant — the bag.
   Shopify asset: assets/reve-cart.js

   Everything here speaks to Shopify's own cart:
     POST /cart/add.js      to add
     POST /cart/change.js   to change a quantity or remove a line
     GET  /cart.js          to read the cart back

   Nothing is faked, so the checkout button, the discounts, the shipping
   rates and the inventory are Shopify's own. If JavaScript is off, the
   product form posts to /cart/add the ordinary way and the /cart page
   carries the whole thing on its own.
   ================================================================== */

(function () {
  // Show the size only, so the bag reads the same before and after a reload.
  function lineSize(item) {
    var size = "";
    (item.options_with_values || []).forEach(function (opt) {
      if (opt.name === "Size") size = opt.value;
    });
    if (!size && item.variant_title && item.variant_title !== "Default Title") size = item.variant_title;
    return size ? '<span class="reve-cart-line__price">Size ' + size + "</span>" : "";
  }

  "use strict";

  var drawer = document.getElementById("reve-cart-drawer");
  var veil = document.getElementById("reve-cart-veil");
  if (!drawer) return;

  var list = drawer.querySelector("[data-reve-cart-lines]");
  var total = drawer.querySelector("[data-reve-cart-total]");
  var empty = drawer.querySelector("[data-reve-cart-empty]");
  var currency = drawer.getAttribute("data-currency") || "USD";
  var opener = null;

  function money(cents) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currency,
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function open() {
    opener = document.activeElement;
    drawer.removeAttribute("hidden");
    if (veil) veil.removeAttribute("hidden");
    document.body.style.overflow = "hidden";
    var first = drawer.querySelector("[data-reve-cart-close]");
    if (first) first.focus();
  }

  function close() {
    drawer.setAttribute("hidden", "");
    if (veil) veil.setAttribute("hidden", "");
    document.body.style.overflow = "";
    if (opener && typeof opener.focus === "function") opener.focus();
  }

  function setCount(count) {
    var nodes = document.querySelectorAll("[data-reve-cart-count]");
    Array.prototype.forEach.call(nodes, function (node) {
      node.textContent = count;
    });
    // keep the screen-reader label in step with the number
    var label = "Open the bag, " + count + (count === 1 ? " item" : " items");
    Array.prototype.forEach.call(document.querySelectorAll('[aria-label^="Open the bag"]'), function (link) {
      link.setAttribute("aria-label", label);
    });
  }

  function render(cart) {
    setCount(cart.item_count);

    if (!list) return;

    if (!cart.items || cart.items.length === 0) {
      list.innerHTML = "";
      if (empty) empty.removeAttribute("hidden");
    } else {
      if (empty) empty.setAttribute("hidden", "");
      list.innerHTML = cart.items
        .map(function (item) {
          var image = item.image
            ? '<img src="' + item.image + '" data-reve-line-img="' + item.key + '" alt="" width="144" height="192" loading="lazy">'
            : "";
          return (
            '<li class="reve-cart-line">' +
            '<a class="reve-cart-line__media" href="' + item.url + '" aria-hidden="true" tabindex="-1">' +
            image +
            "</a>" +
            '<span class="reve-cart-line__text">' +
            '<a class="reve-cart-line__title" href="' + item.url + '">' +
            item.product_title +
            "</a>" +
            lineSize(item) +
            '<span class="reve-cart-line__price">' +
            money(item.final_line_price) +
            "</span>" +
            '<span class="reve-cart-line__qty">' +
            '<label class="reve-visually-hidden" for="reve-qty-' + item.key + '">Quantity</label>' +
            '<input class="field-input" id="reve-qty-' + item.key + '" type="number" min="0" max="99" value="' +
            item.quantity +
            '" data-reve-qty="' + item.key + '">' +
            '<a class="reve-remove" href="/cart/change?id=' + item.key + '&amp;quantity=0" data-reve-remove="' + item.key + '" aria-label="Remove ' + item.product_title + ' from the bag">Remove</a>' +
            "</span>" +
            "</span>" +
            "</li>"
          );
        })
        .join("");
    }

    if (total) total.textContent = money(cart.total_price);
    correctLineImages(cart);
  }

  /* A size can carry its own photograph, which the cart would then show. The
     house shows the piece's first photograph instead, so each line is put
     right once the product's own data arrives. Cached per product, and it
     falls back to whatever the cart gave us. */
  var firstImage = {};

  function correctLineImages(cart) {
    (cart.items || []).forEach(function (item) {
      var path = String(item.url || "").split("?")[0];
      if (!path) return;
      if (Object.prototype.hasOwnProperty.call(firstImage, path)) {
        apply(item, firstImage[path]);
        return;
      }
      firstImage[path] = "";
      fetch(path + ".js", { headers: { Accept: "application/json" } })
        .then(function (response) { return response.json(); })
        .then(function (product) {
          var src = product && product.images && product.images[0] ? product.images[0] : "";
          firstImage[path] = src;
          apply(item, src);
        })
        .catch(function () {});
    });

    function apply(item, src) {
      if (!src || !list) return;
      var node = list.querySelector('[data-reve-line-img="' + item.key + '"]');
      if (node) node.src = src.split("?")[0] + "?width=576";
    }
  }

  function readCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (response) {
        return response.json();
      })
      .then(render);
  }

  function change(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (response) {
        return response.json();
      })
      .then(render);
  }

  /* add to cart, from any product form on the site */
  document.addEventListener("submit", function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (typeof window.fetch !== "function") return; /* let it post normally */

    event.preventDefault();

    var submit = form.querySelector('[type="submit"]');
    if (submit) submit.setAttribute("aria-busy", "true");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        if (submit) submit.removeAttribute("aria-busy");
        return readCart();
      })
      .then(open)
      .catch(function () {
        if (submit) submit.removeAttribute("aria-busy");
        form.submit(); /* the plain post, as a last resort */
      });
  });

  /* quantity and remove, inside the drawer */
  drawer.addEventListener("change", function (event) {
    var input = event.target.closest ? event.target.closest("[data-reve-qty]") : null;
    if (!input) return;
    change(input.getAttribute("data-reve-qty"), parseInt(input.value, 10));
  });

  drawer.addEventListener("click", function (event) {
    var remove = event.target.closest ? event.target.closest("[data-reve-remove]") : null;
    if (!remove) return;
    event.preventDefault();
    change(remove.getAttribute("data-reve-remove"), 0);
  });

  /* openers, closers and the escape key */
  document.addEventListener("click", function (event) {
    if (event.target.closest && event.target.closest("[data-reve-cart-open]")) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest && event.target.closest("[data-reve-cart-close]")) {
      event.preventDefault();
      close();
    }
  });

  if (veil) veil.addEventListener("click", close);

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    if (drawer.hasAttribute("hidden")) return;
    close();
  });
})();
